import { render, staticRenderFns } from "./rePassword.vue?vue&type=template&id=a9bc5bd2&"
import script from "./rePassword.vue?vue&type=script&lang=js&"
export * from "./rePassword.vue?vue&type=script&lang=js&"
import style0 from "./rePassword.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports